var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.25,
    height: 22,
    viewBox: "0 0 22.25 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shopping-cart",
    transform: "translate(-0.5 -1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342",
    transform: "translate(0.75 1.75)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(4.375 19)",
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(18.375 19)",
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    d: "M.942-.75A1.692,1.692,0,1,1-.75.942,1.694,1.694,0,0,1,.942-.75Zm0,1.933A.242.242,0,1,0,.7.942.242.242,0,0,0,.942,1.183Z",
    transform: "translate(4.617 19.117)",
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    d: "M.942-.75A1.692,1.692,0,1,1-.75.942,1.694,1.694,0,0,1,.942-.75Zm0,1.933A.242.242,0,1,0,.7.942.242.242,0,0,0,.942,1.183Z",
    transform: "translate(18.15 19.117)",
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M19.342,17.2H5.808a.725.725,0,0,1-.719-.629L3.24,2.7H.975a.725.725,0,0,1,0-1.45h2.9a.725.725,0,0,1,.719.629l.561,4.2H21.275a.725.725,0,0,1,.711.867l-1.933,9.667A.725.725,0,0,1,19.342,17.2Zm-12.9-1.45h12.3l1.643-8.217H5.348Z",
    transform: "translate(-0.25 -1.25)",
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144_-_Outline",
    "data-name": "Path 144 - Outline",
    d: "M19.342,17.45H5.808a.978.978,0,0,1-.966-.846L3.021,2.95H.975A.975.975,0,1,1,.975,1h2.9a.978.978,0,0,1,.966.846l.532,3.987h15.9A.975.975,0,0,1,22.231,7L20.3,16.666A.978.978,0,0,1,19.342,17.45ZM.975,1.5a.475.475,0,1,0,0,.95H3.459L5.338,16.538a.476.476,0,0,0,.471.412H19.342a.476.476,0,0,0,.466-.382L21.741,6.9a.475.475,0,0,0-.466-.568H4.935L4.346,1.912A.476.476,0,0,0,3.875,1.5ZM18.952,16H6.224L5.062,7.283H20.7Zm-12.29-.5h11.88l1.543-7.717H5.633Z",
    transform: "translate(-0.25 -1.25)",
    fill: "#1f2937"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.2ce68290dcaf76e8693a43b83696847e.svg";
export { ForwardRef as ReactComponent };